import { Dispatch, SetStateAction, useEffect } from "react";
import { Chip, Body1 } from "../../components";
import { MultipleSelect, MultipleSelectAllProps } from "./MultipleSelect";

interface MultipleSelectDefaultProps<T> {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  values: T[];
  setValues: Dispatch<SetStateAction<T[]>>;
  isLazyLoaded?: boolean;
}

interface MultipleSelectDefaultAllProps<T>
  extends Omit<
      MultipleSelectAllProps<T>,
      "selectedValue" | "setSelectedValue" | "onOpen" | "onClose" | "renderTags" | "open"
    >,
    MultipleSelectDefaultProps<T> {}

export function MultipleSelectDefaultAll<T>({
  setOpen,
  open,
  values,
  setValues,
  isLazyLoaded,
  ...props
}: MultipleSelectDefaultAllProps<T>) {
  useEffect(() => {
    (values.length === 0 || props.disabled) && !open && setValues(["All" as unknown as T]);
  }, [open, props.disabled, setValues, values.length]);
  const defaultGetOptionLabel = (option: unknown) => (typeof option === "string" ? option : JSON.stringify(option));
  return (
    <MultipleSelect
      selectedValue={values}
      setSelectedValue={(val) => setValues(val)}
      onOpen={() => {
        setOpen(true);
        (values[0] as unknown as string) === "All" && setValues([]);
      }}
      onClose={() => {
        setOpen(false);
      }}
      isLazyLoaded={isLazyLoaded}
      renderTags={(value, getTagProps) =>
        value.map((tag, index) =>
          (tag as unknown as string) === "All" ? (
            <Body1 style={{ marginLeft: "4px" }}>All</Body1>
          ) : (
            <Chip
              size="small"
              label={(props.getOptionLabel || defaultGetOptionLabel)(tag)}
              {...getTagProps({ index })}
            />
          )
        )
      }
      open={open}
      isAllSelected={!open && values.length === 1 && (values[0] as unknown as string) === "All"}
      isDefaultAll
      {...props}
    />
  );
}
